import { cx } from '@linaria/core'

import { useFoodSWR } from '~/api-client/food_api'
import { Gift, User } from '~/api-definition/definition'
import { AppImage } from '~/components/data-display/AppImage'

export const GiftCard: React.FC<{
  fromUser: User
  toUser: User | undefined
  gift: Gift
  className?: string
}> = (props) => {
  return (
    <div
      className={cx(
        'bg-primary-cv1 bg-opacity-30 p-5 rounded-md flex items-center flex-col gap-2 select-none',
        props.className
      )}
    >
      <AppImage
        variant={{
          type: 'cover',
          coverPosition: 'center',
        }}
        rounded="none"
        src={props.gift.imageUrl}
        alt={props.gift.giftName}
        height={100}
        width={100}
      />
      <div className="text-xs font-bold text-center">
        <GiftCardMessage
          fromUser={props.fromUser}
          toUser={props.toUser}
          gift={props.gift}
        />
      </div>
    </div>
  )
}

const GiftCardMessage: React.FC<{
  fromUser: User
  toUser: User | undefined
  gift: Gift
}> = (props) => {
  const userMe = useFoodSWR('/user/me', {})

  if (props.fromUser.userId === userMe.data?.user.userId) {
    return (
      <>
        {props.toUser?.displayName}に<br />
        {props.gift.giftName}を贈りました
      </>
    )
  } else {
    if (props.toUser?.userId === userMe.data?.user.userId) {
      return (
        <>
          {props.fromUser.displayName}から
          <br />
          {props.gift.giftName}が贈られました
        </>
      )
    } else {
      return (
        <>
          {props.fromUser.displayName}が{props.toUser?.displayName}に
          <br />
          {props.gift.giftName}を贈りました
        </>
      )
    }
  }
}
